module.exports = __webpack_public_path__ + "img/top1.9c82ac52.jpg";